import { useFormikContext } from 'formik'
import { useContext, useMemo } from 'react'
import { ModalSidebarContext } from '../../../../../../components/ModalSidebar'

const useSaveButton = () => {
  const { submitForm } = useFormikContext()
  const { nextStep } = useContext(ModalSidebarContext)

  // save button configuration for the ModalPanel
  const saveButton = useMemo(
    () => ({
      label: 'DEFAULT_SETTINGS.SAVE_DEFAULT_SETTINGS',
      onClick: () => {
        submitForm()
        nextStep()
      },
    }),
    [submitForm, nextStep],
  )

  return saveButton
}

export default useSaveButton
